import { END_POINTS } from "../constants/url";
import emptySplitApi from "../utils/rtk";

interface CommonResponseType {
  statusCode: number;
  message: string;
}

export const NewsApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    addNews: builder.mutation<CommonResponseType, any>({
      query: (body) => ({
        url: END_POINTS.News,
        method: "POST",
        body,
      }),
    }),
    getNews: builder.query<
      CommonResponseType & {
        data: {
          data: any[];
          total: number;
        };
      },
      {
        from: number;
        size: number;
        search: string;
      }
    >({
      query: ({ from, size, search }) => ({
        url:
          `${END_POINTS.News}?from=${from}&size=${size}` +
          (search?.length ? `&search=${search}` : ""),
        method: "GET",
      }),
    }),
    getNewsDetail: builder.query<
      CommonResponseType & {
        data: any;
      },
      {
        id: string;
      }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.News}/${id}`,
        method: "GET",
      }),
    }),
    updateNews: builder.mutation<
      CommonResponseType & { data: any },
      { body: any; id: string }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.News}/${id}`,
        method: "PUT",
        body,
      }),
    }),
    deleteNews: builder.mutation<CommonResponseType, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.News}/${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useAddNewsMutation,
  useLazyGetNewsQuery,
  useLazyGetNewsDetailQuery,
  useUpdateNewsMutation,
  useDeleteNewsMutation,
} = NewsApi;
